/* @jsx h */
import { defineComponent, h } from "vue";

export type NumPadProps = {
  value: string;
  onChange: (value: string) => void;
  secureDisplay?: boolean;
};
export const NumPad = defineComponent<NumPadProps>({
  name: "NumPad",
  props: ["value", "onChange", "secureDisplay"],
  setup(props) {
    const handleAppend = (num: string) => {
      const nv = props.value + num;
      props.onChange(nv);
    };

    const handleDecimal = () => {
      if (!props.value.includes(".")) {
        const nv = props.value + ".";
        props.onChange(nv);
      }
    };

    const handleBackspace = () => {
      const nv = props.value.slice(0, -1);
      props.onChange(nv);
    };

    return () => {
      return (
        <>
          <div class="mb-4 text-center">
            <div class="text-4xl font-mono tracking-widest  text-accent py-2 px-4 rounded">
              {props.value
                ? props.secureDisplay
                  ? props.value
                      .split("")
                      .map(() => "•")
                      .join("")
                  : props.value
                : "-"}
            </div>
          </div>
          <div class="w-full grid grid-cols-3 gap-4 font-mono">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <button
                key={num}
                style="border-radius: 50%;"
                class="btn btn-secondary mx-auto my-1 w-16 h-16 lg:w-20 lg:h-20   text-3xl "
                onClick={() => handleAppend(num.toString())}
              >
                {num}
              </button>
            ))}
            <button
              style="border-radius: 50%;"
              class="btn btn-secondary  mx-auto my-1 w-16 h-16 lg:w-20 lg:h-20   text-3xl"
              onClick={handleDecimal}
            >
              •
            </button>
            <button
              style="border-radius: 50%;"
              class="btn btn-secondary  mx-auto my-1 w-16 h-16 lg:w-20 lg:h-20   text-3xl"
              onClick={() => handleAppend("0")}
            >
              0
            </button>
            <button
              style="border-radius: 50%;"
              class="btn btn-accent  mx-auto my-1 w-16 h-16 lg:w-20 lg:h-20   text-3xl"
              onClick={handleBackspace}
            >
              <span class="material-symbols-outlined">backspace</span>
            </button>
          </div>
        </>
      );
    };
  },
});
